import React, { useState, useEffect } from "react";
import VopHeader from "components/vop_header";

import VopFooter from "components/vop_footer";

import HomeHeader from "components/HomeHeader";
import "./style.scss";
import { queryRequestResult, getApiArticleDetail } from "utils/api";

import { observer } from "mobx-react-lite";
import { Button } from "@jdcfe/legao";
import Utils from "utils/utils.js";

const Apitest = observer(() => {
  const [isRootKey, setIsRootKey] = useState(false);
  const [isAllShow, setIsAllShow] = useState(false);
  const [groupName, setGroupName] = useState("");
  const [apiName, setApiName] = useState("");
  const [znName, setZnName] = useState("");

  // 用于 开发环境测试 写死
  const [paramAppToken, setParamAppToken] = useState("");
  const [paramAppKey, setParamAppKey] = useState("");
  const [paramAppSecret, setParamAppSecret] = useState("");
  // const [paramAppToken, setParamAppToken] = useState('61401710cfec42a0bc4f71a2b846e571nje0');
  // const [paramAppKey, setParamAppKey] = useState('2F7CAA36EB57AB096CED1B0BAC6AD94D');
  // const [paramAppSecret, setParamAppSecret] = useState('aaef1c27507b4d4c9b660abfe323bee1');

  const [version, setVersion] = useState("2.0");
  const [paramAppTokenError, setParamAppTokenError] = useState(false);
  const [paramAppKeyError, setParamAppKeyError] = useState(false);
  const [paramAppSecretError, setParamAppSecretError] = useState(false);
  const [paramJsonError, setParamJsonError] = useState([]);
  const [result, setResult] = useState(null);

  const [paramsValue, setParamsValue] = useState({});
  const [requestParams, setRequestParams] = useState([]);
  const [requestParamsAll, setRequestParamsAll] = useState([]);

  useEffect(() => {
    document.title = "京东VOP开放平台-api测试";
    window.scrollTo(0, 0);
    init();
  }, []);

  function deleteChildren(arr, childrenKey) {
    let childs = arr;
    if (Array.isArray(arr) && arr.length) {
      for (let i = childs.length; i--; i > 0) {
        if (childs[i][childrenKey]) {
          if (childs[i][childrenKey].length) {
            childs[i][childrenKey].forEach(
              (item) => (item.parentInfo = childs[i])
            );
            deleteChildren(childs[i][childrenKey], childrenKey);
          } else {
            delete childs[i][childrenKey];
            if (childs[i].systemValue) {
              childs.splice(i, 1);
            } else if (childs[i]?.paramName == "sourceType") {
              //sourceType为固定值，单独处理
              childs.splice(i, 1);
            }
          }
        }
      }
    }
    return arr;
  }

  const init = () => {
    setGroupName(Utils.getQueryVariable("groupName"));
    setZnName(Utils.getQueryVariable("znName"));
    setApiName(Utils.getQueryVariable("apiName"));

    // 获取 Api 文档详情
    getApiArticleDetail({
      articleId: Utils.getQueryVariable("apiId"),
    }).then((res) => {
      if (res.data.success) {
        const requestParams = res.data.result.method;
        let params = deleteChildren(requestParams.elements, "elements");
        let tag = [];

        params.forEach((param) => {
          if (param.elements) {
            tag = tag.concat(param.elements);
            allFirstParam(param);
          }
        });
        setRequestParams(tag);
      }
    });
  };

  const allFirstParam = (params) => {
    if (params.elements) {
      params.elements.forEach((p, i) => {
        if (p.type.toLocaleLowerCase().indexOf("list") > -1) {
          console.log(p, p.elements[0].paramName == "---");
          if (p.elements[0].paramName == "---") {
            setIsRootKey(true);
            setAllFirstParam(p);
          } else {
            setIsAllShow(true);
            allFirstParam(p);
          }
        } else {
          allFirstParam(p);
        }
      });
    } else {
      setAllFirstParam(params);
    }
  };

  const setAllFirstParam = (param) => {
    requestParamsAll.push(param);
    setRequestParamsAll(requestParamsAll);
    paramsValue[param.paramName] = param.value;
    paramJsonError.push(false);
    setParamsValue(paramsValue);
    setParamJsonError(paramJsonError);
  };

  const submit = () => {
    if (paramAppToken == "") {
      setParamAppTokenError(true);
      return;
    } else {
      setParamAppTokenError(false);
    }
    if (paramAppKey == "") {
      setParamAppKeyError(true);
      return;
    } else {
      setParamAppKeyError(false);
    }
    if (paramAppSecret == "") {
      setParamAppSecretError(true);
      return;
    } else {
      setParamAppSecretError(false);
    }

    // 判断必填参数是否有值
    for (let i = 0; i < requestParamsAll.length; i++) {
      let p = requestParamsAll[i];
      if (p.required && !paramsValue[p.paramName]) {
        paramJsonError[i] = true;
        setParamJsonError([...paramJsonError]);
        return;
      }
    }
    let childParamJson = {},
      rootParams = {};
    console.log("pre-childParamJson", childParamJson);
    console.log("pre-requestParams", requestParams);
    jointParams(childParamJson, requestParams);
    console.log("childParamJson", childParamJson);
    if (isRootKey) {
      rootParams[requestParams[0].parentInfo.paramName] = childParamJson;
    } else {
      rootParams = childParamJson;
    }

    let data = {
      paramAppToken,
      paramAppKey,
      paramAppSecret,
      paramJson: JSON.stringify(rootParams),
      method: apiName,
      version: version,
    };
    queryRequestResult(data).then((res) => {
      if (res?.data?.success) {
        let result = res.data.result;
        setResult(result);
      }
    });
  };

  // 循环遍历 所有 params 进行最终 参数合并
  const jointParams = (target, param) => {
    param.forEach((p, ix) => {
      const type = p.type.toLocaleLowerCase();
      if (type.indexOf("list") > -1) {
        if (p.elements[0].paramName == "---") {
          target[p.paramName] = paramsValue[p.paramName]
            ? JSON.parse(
                paramsValue[p.paramName]
                  .replace(/\s*/g, "")
                  .replace(/(\w+):/g, '"$1":')
              )
            : [];
        } else {
          let pN = p.elements[0];
          let typeN = pN.type.toLocaleLowerCase();

          let arrParamsValue = paramsValue[pN.paramName].split(",");
          if (typeN.indexOf("integer") > -1 || typeN.indexOf("long") > -1) {
            target[pN.paramName] = Number(paramsValue[pN.paramName]);
            arrParamsValue = arrParamsValue.map((p) => Number(p));
          }
          target[pN.paramName] = arrParamsValue;
        }
      } else if (p.elements) {
        if (isAllShow) {
          jointParams(target, p.elements);
        } else {
          if (type.indexOf("req") > -1 || type.indexOf("map") > -1) {
            target[p.paramName] = {};
          }
          //有elements时，elements中的type值增加拼参
          let pN = p.elements[0];
          target[pN.paramName] = paramsValue[pN.paramName];
          jointParams(target[p.paramName], p.elements);
        }
      } else {
        if (target && paramsValue[p.paramName]) {
          if (type.indexOf("integer") > -1 || type.indexOf("long") > -1) {
            //和后端bowen沟通 传字符串即可
            target[p.paramName] = paramsValue[p.paramName];
          } else {
            target[p.paramName] = paramsValue[p.paramName];
          }
        }
      }
    });
  };

  const tipsRender = (param) => {
    if (
      param.elements &&
      param.elements.length > 0 &&
      param.type.toLocaleLowerCase().indexOf("list") > -1
    ) {
      return <span>（请根据文档层级拼写数组JSON串）</span>;
    }
    return "";
  };

  return (
    <React.Fragment>
      <div className="jdw-container">
        <div className="jdw-row">
          <div className="jdw-column">
            <div
              className="jdw-widget"
              data-name="vop_header"
              data-version="6.0.0"
            >
              <VopHeader contentWidth="1200px">
                <HomeHeader />
              </VopHeader>
            </div>
          </div>
        </div>
      </div>

      <div className="apitest-content">
        <div className="empty"></div>
        <div className="title">
          <div className="nav">
            <span>API文档/</span>
            <span>{groupName}/</span>
            <span>{znName}</span>
          </div>
        </div>
        <div className="main">
          <p className="main-title">API测试工具</p>
          <main className="main-content">
            <div className="main-left">
              <div className="main-form">
                <div className="line">
                  <span className="line-title">API类目:</span>
                  <span className="line-name">{znName}</span>
                </div>
                <div className="line">
                  <span className="line-title">方法名:</span>
                  <span className="line-name">{apiName}</span>
                </div>
                <div className="line">
                  <span className="line-title">版本号:</span>
                  <span className="line-name">{version}</span>
                </div>
                <div className="line linePrams">
                  <span className="line-title1 require"> AccessToken</span>
                  <span className="line-name">
                    <input
                      type="text"
                      className="input"
                      value={paramAppToken}
                      placeholder="7e149bf*******055izjm"
                      onChange={(e) => {
                        let value = e.target.value;
                        setParamAppToken(value);
                      }}
                      onBlur={(e) => {
                        let value = e.target.value;
                        setParamAppTokenError(value == "" ? true : false);
                      }}
                    />
                  </span>
                  {paramAppTokenError ? (
                    <div className="error-tip">请输入AccessToken</div>
                  ) : null}
                </div>
                <div className="line linePrams">
                  <span className="line-title1 require"> AppKey</span>
                  <span className="line-name">
                    <input
                      type="text"
                      className="input"
                      value={paramAppKey}
                      placeholder="2F7C********0BAC6AD94D"
                      onChange={(e) => {
                        let value = e.target.value;
                        setParamAppKey(value);
                      }}
                      onBlur={(e) => {
                        let value = e.target.value;
                        setParamAppKeyError(value == "" ? true : false);
                      }}
                    />
                  </span>
                  {paramAppKeyError ? (
                    <div className="error-tip">请输入AppKey</div>
                  ) : null}
                </div>
                <div className="line linePrams">
                  <span className="line-title1 require"> AppSecret</span>
                  <span className="line-name">
                    <input
                      type="text"
                      className="input"
                      value={paramAppSecret}
                      placeholder="aaef********bee1"
                      onChange={(e) => {
                        let value = e.target.value;
                        setParamAppSecret(value);
                      }}
                      onBlur={(e) => {
                        let value = e.target.value;
                        setParamAppSecretError(value == "" ? true : false);
                      }}
                    />
                  </span>
                  {paramAppSecretError ? (
                    <div className="error-tip">请输入AppSecret</div>
                  ) : null}
                </div>
                <div className="params">
                  <div className="tag-desc"></div>
                  <div>请填写参数值</div>
                </div>
                <div className="requestParamsBox">
                  {requestParamsAll.map((params, index) => {
                    return (
                      <div className={`line linePrams`} key={index}>
                        <span
                          className={`line-title1 ${
                            params.required ? "require" : null
                          }`}
                        >
                          {" "}
                          <span>{params.paramName}</span>
                          {tipsRender(params)}
                        </span>
                        <div className="line-name ">
                          <input
                            type="text"
                            className="input"
                            defaultValue={paramsValue[params.paramName]}
                            onChange={(e) => {
                              let value = e.target.value;
                              paramsValue[params.paramName] = value;
                              setParamsValue(paramsValue);
                            }}
                            onBlur={(e) => {
                              let value = e.target.value;
                              paramJsonError[index] =
                                value == "" ? true : false;
                              setParamJsonError([...paramJsonError]);
                            }}
                          />

                          <div className="input-name" title={params.desc}>
                            {params.desc}
                          </div>
                        </div>
                        {paramJsonError[index] && params.required ? (
                          <div className="error-tip">
                            请输入{params.paramName} 参数
                          </div>
                        ) : null}
                      </div>
                    );
                  })}
                </div>

                <Button
                  className="submit"
                  styleType="primary"
                  onClick={() => {
                    submit();
                  }}
                  clstag="pageclick|keycount|VopOpenIndex_1602911919488|31"
                >
                  <span className={`lg-btn-text`}>提交测试</span>
                </Button>
              </div>
            </div>
            <div className="main-right">
              <div className="result">
                <div className="content-list">
                  <div className="result-title">请求地址</div>
                  <div className="result-content">
                    {result ? JSON.stringify(result.url) : ""}
                  </div>
                </div>
                <div className="content-list">
                  <div className="result-title">相应结果</div>
                  <div className="result-content">
                    {result ? JSON.stringify(result.result) : ""}
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>

      <div className="jdw-container">
        <div className="jdw-row">
          <div className="jdw-column">
            <div
              className="jdw-widget"
              data-name="vop_footer"
              data-version="2.0.0"
            >
              <VopFooter />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
});

export default Apitest;
